import React from 'react';
import { View, Text, ImageBackground, Image, ScrollView, Dimensions,TouchableHighlight,TouchableWithoutFeedback,TouchableOpacity} from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';
import style from './perfilMulti/style';
import Menu from '../menu';
import Modal from "modal-react-native-web";
import api from '../config/api_urls';
import PopUpPerfilImatge from '../PopUps/perfilImatge';


export default class ImatgesItinerari extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.route.params;
    this.state['premis'] = [];
    this.state['imatge'] = [];
    this.state['postes'] = [];
    this.state['gameList']=[];
    this.state['visible']= false;
    this.state['SobreVisible'] = false;
    this.state['imgClick'] = 0;
    this.state['jaRenderitzat'] = false;
    this.state['currentPremi'] = {};
    this.state['modalVisible'] = false;

    if (typeof this.state.nom === 'undefined') {
      this.state['nom'] = '';
    }
    if (typeof this.state.cookies === 'undefined') {
      this.state['cookies'] = '';
    }
  }
  
  componentDidMount() {
    this.getGameList();
    this.getNom();
    // this.isCardRended();
    AsyncStorage.setItem('anarCredits',true);
    setTimeout(()=>{this.getGamePoints()},50)     
  }

 getGamePoints = async () =>{
   let punts = 0;
   let length = 0;
   let postes = []
   let passedPois = []
  for( let i = 0; i < this.state.gameList.length;i++){
    const value = await AsyncStorage.getItem('Game'+[this.state.gameList[i]]);
    if(value !== null){
      //console.log(JSON.parse(value).idioma);
      if(JSON.parse(value).idioma == this.state.idioma){
        punts += JSON.parse(value).score;
        postes += JSON.parse(value).gainedRewardsIds+",";
        passedPois += JSON.parse(value).passedPoisIds+",";
        let aux = passedPois.split(',')
        length = aux.length -1;
      }
    }
  }
  this.setState({joc:{score : punts , gainedRewardsIds : postes , passedPoisIds : passedPois , pois : length}})
 }

  getGameList = async () => {
    try {
      const value = await AsyncStorage.getItem('Gamelist');
      if (value !== null) {
        this.setState({ gameList: value.split(",") });
      } 
    } catch (e) {
      console.log(e);
    }
  }
  getNom = async () => {
    try {
      const value = await AsyncStorage.getItem('nom');
      if (value !== null) {
        this.setState({ nom: value });
      }
    } catch (e) {
      console.log(e);
    }
  }


  imatges(){
    console.log(this.state.currentGameView.id);
    return this.state.projecte.premis.map((data, i) => {   
      
      if(data.superPremi){
        if(i+1 == this.state.joc.pois){ //get last
          return(this.animacioCarta(data,i))
        }

      }else{
       return(this.renderitzarPremi(data,i))
      }
    })
  } 

animacioCarta(data,i){
  if(!this.state.jaRenderitzat){  
    setTimeout(()=>{ this.setSobreVisible(true); this.setState({imgClick : i});  this.setState({jaRenderitzat : true});},100)
     return(null)
    }else{
      return(this.superPremi(data,i))
    }
}
showSuperPremi() {
  return this.state.projecte.premis.map((data, i) => {
    if (data.superPremi && data.game == this.state.currentGameView.id) {
      let finished = this.state.finished_games
        ? this.state.finished_games.find(
            (game) => game.gameId == this.state.currentGameView.id
          )
        : null;
      if (finished) {
        return (
          <TouchableOpacity style={[style.superPremiContainer,{width:'120%',height:'120%',marginTop:'20%'}]} onPress={()=>{this.setModalVisible(true) ; this.setState({currentPremi : data} ) }} >
            {/* <View style={style.superPremiContainer}> */}
              <Image
                style={style.image}
                source={{
                  uri:
                    api.api_url +
                    data.Premi.url
                }}
              />
            {/* </View> */}
          </TouchableOpacity>
        );
      
      } else {
        return (
          <View style={style.superPremiContainer}>
            <Image
              style={style.image}
              source={{ uri: api.api_url + this.state.recursos.find((e) => e.tipus_recurs == "super_premi")["imatge_recurs"].url }}
            />
          </View>
        );
      }
    }
  });
}
//Renderitzar Premi tant vertical com horitzontal
// this.isInRewardsPoints(data['poi_id'+this.state.idioma]) ? 
renderitzarPremi(data,i){
  if(data.game == this.state.currentGameView.id) {

    if(this.state.joc.passedPoisIds.includes(data['poi_id'+this.state.idioma])){
      return(
        <View style={[style.premiContainer]} >
        <TouchableOpacity onPress={()=>{this.setModalVisible(true) ; this.setState({currentPremi : data} ) }} >
          <Image style={[style.premiImage]} source={{uri: api.api_url + data.Premi.url}}/>
        </TouchableOpacity>
        </View>
        )
    }else
    {
      return(
        <View style={[style.premiContainer]} >
        <TouchableOpacity >
          <Image style={[style.premiImage,{opacity:0.3}]} source={{uri: api.api_url + data.Premi.url}}/>
        </TouchableOpacity>
        </View>
        )
    }
  }
}

isInRewardsPoints(id){
  if(this.state.joc.gainedRewardsIds != null && this.state.joc.gainedRewardsIds != undefined){
      if(this.state.joc.gainedRewardsIds.includes(id)){
        return true ;
      }else return false; 
    }
  return false;
}

isInPassedPois(id){
 if(this.state.joc.passedPoisIds != null){
  return(this.state.joc.passedPoisIds.includes(id))
 }else{
  return(false)
 }
  
}


/*********** 
  MODAL
 ***********/
setModalVisible = visible => {
  this.setState({ modalVisible: visible });
};

setSobreVisible = SobreVisible => {
  this.setState({SobreVisible})
}


render() {
    return (
        <View style={{flex:1}}>
        
          <ImageBackground source={this.state.projecte['FonsPantalla7'] ? { uri: api.api_url + this.state.projecte['FonsPantalla7'].url } : null} style={style.imageBackground}>
          {this.state.modalVisible ? PopUpPerfilImatge(this.state.currentPremi,this.state.modalVisible,this.setModalVisible,this.state.idioma) : null}
            <View style={{flex:20,justifyContent:'center',alignItems:'center',paddingTop:'10%'}}>
              <View style={style.boxNom}>
                <Text style={style.nom}>{this.state.currentGameView['Nom'+this.state.idioma]}</Text>
              </View>
            </View>
            <View style={{flex:15 , flexDirection:'row' }}>
        
              <View style={{flex:1, justifyContent:'center',alignItems:'center', width:'40%',paddingRight:'5%'}}>
                {this.showSuperPremi()}
              </View>
            </View>
            <View style={{ flexDirection: 'row',  flexWrap: 'wrap',justifyContent:'center', paddingTop: 20, alignItems:'center' }}>              
                {this.imatges()}
            </View>
            <View style={{flex:40,alignContent:'center',alignSelf:'center'}}>
              <ScrollView style={{flex:1, maxHeight: "100%",width: Dimensions.get('screen').width * 0.7 ,}}>
               
              </ScrollView>
            </View>
            <View style={{ flex: 2, bottom:0,left:0,right:0, position:'fixed', }}>
                  <Menu projecte={this.state}></Menu>
                </View>
          </ImageBackground>
        </View>
      );
}
}
